exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-list {\n  padding: 0px;\n}\n.app-list .v-toolbar .v-toolbar__content {\n  height: 60px !important;\n}\n.app-list .v-input--selection-controls__input > .accent--text {\n  color: rgba(0,0,0,0.2) !important;\n}\n.app-list .icon-green {\n  color: #27ae60 !important;\n}\n.app-list .icon-yellow {\n  color: #ff9800 !important;\n}\n.app-list .icon-red {\n  color: #eb5757 !important;\n}\n", ""]);

// exports
